(function () {
    'use strict';

    angular
        .module('app.paymentTemplates')
        .controller('PaymentTemplatesDetailsController', PaymentTemplatesDetailsController);

    PaymentTemplatesDetailsController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function PaymentTemplatesDetailsController($state, $stateParams, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
   
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.isNew = isNew;
        vm.preventDelete = preventDelete;
        vm.isLoading = true;
        vm.isMazevo = common.userService.isMazevoApi();
        vm.isCollegeNet = common.userService.isCollegeNetApi();
        vm.isEms = common.userService.isEmsApiType();
        vm.showCustomNoteBox = common.userService.tenantId() == "15" || common.userService.tenantId() == "1";
       
        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItem(), getLookups(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                vm.isLoading = false;
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                if (vm.licenseInfo.NumberOfPaymentTemplatesLicensed < vm.licenseInfo.NumberOfPaymentTemplatesInUse) {
                    $state.go('404');
                }
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("paymenttemplates.list");
        }

        function preventDelete() {
            if ($stateParams.id <= 0) {
                return true;
            }
            
            return false;
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Payment Template')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/PaymentTemplates/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === '';
        }

        function getLookups() {
            return dataservice.getItems('api/PaymentTemplates/GetLookups').then(function (response) {
                vm.departments = response.data.Departments;
                vm.paymentGateways = response.data.PaymentGateways;
                vm.paymentTypes = response.data.PaymentTypes;
                vm.reminderTypes = response.data.ReminderTypes;
                vm.logos = response.data.Logos;
            }, function (error) { });
        }

       
        function getItem() {
            var val = $stateParams.id;
            if (val === '') {
                vm.item = {};
                vm.item.EnableDeposits = 0;
                vm.item.SendConfirmationEmail = 0;
                vm.item.IncludeCustomNoteBox = 0;
                vm.item.AllowCustomInvoiceAmount = 0;
                vm.item.ReservationIdBoxLabel = "Reservation Id";
                vm.item.CustomerBoxLabel = "Group Name";
                vm.item.InvoiceBoxLabel = "Invoice Number";
                
                vm.item.DefaultButton = 1;
                vm.item.PayInvoiceLabel = "Pay an Invoice";
                vm.item.PayDepositLabel = "Make a Deposit for a Future Event";

                common.setAuditInfo(vm.item);
                if (vm.isCollegeNet) {
                    vm.item.EmsDepartmentId = 0;
                    vm.item.EmsPaymentTypeId = 0;
                }

                return vm.item;
            }
         
            return dataservice.getItem("api/PaymentTemplates/" + val)
                .then(function (response) {
                    if (response) {
                        vm.item = response.data;
                        common.setAuditInfo(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function save() {
            vm.isSaving = true;

            dataservice.saveItem('api/PaymentTemplates', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
